import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { getWhatsAppLink } from '../../utils/whatsapp';
const automationTiers = [{
  key: 'start',
  name: 'START',
  desc: 'Para comenzar a automatizar.',
  setup: '$1.200.000',
  monthly: '$300.000/mes',
  featured: false,
  capabilities: ['WhatsApp + IA', 'Captura de leads', 'Respuestas automáticas', 'CRM básico', 'Transferencia humana'],
  whatsapp: 'Hola ORIGEN, quiero START.',
  cta: 'Quiero START'
}, {
  key: 'growth',
  name: 'GROWTH',
  badge: 'MÁS ELEGIDO',
  desc: 'Para convertir la atención en un proceso comercial.',
  setup: '$2.500.000',
  monthly: '$650.000/mes',
  featured: true,
  capabilities: ['IA + WhatsApp', 'Calificación avanzada', 'CRM', 'Agenda', 'Seguimiento y reactivación'],
  whatsapp: 'Hola ORIGEN, quiero GROWTH.',
  cta: 'Quiero GROWTH'
}, {
  key: 'pro',
  name: 'PRO',
  desc: 'Para empresas con procesos más complejos.',
  setup: '$4.500.000',
  monthly: '$1.200.000/mes',
  featured: false,
  capabilities: ['Automatizaciones avanzadas', 'Integraciones', 'Multi-canal', 'Flujos personalizados', 'Dashboards avanzados'],
  whatsapp: 'Hola ORIGEN, quiero PRO.',
  cta: 'Quiero PRO'
}];
export function AutomationTiers() {
  return <section id="precios" className="bg-arena py-[56px] md:py-[88px]" data-id="element-64" data-mp="2fk9n30y5i14p">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-65" data-mp="2klp7qrwf25mk">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-12 md:mb-14 text-center max-w-[520px] mx-auto" data-id="element-66" data-mp="25nes2s136iv6">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-4" data-id="element-67" data-mp="8v4rtmb6sf6k">
            ELIGE CÓMO QUIERES AUTOMATIZAR
          </span>
          <h2 className="font-display text-[28px] md:text-[38px] font-bold text-carbon leading-[1.15]" data-id="element-68" data-mp="7f91w70b4gie">
            Tres niveles. Un mismo sistema.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch" data-id="element-69" data-mp="3tlo5ynv1eq3o">
          {automationTiers.map((tier, idx) => <motion.div key={tier.key} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: idx * 0.08
        }} className={`relative flex flex-col rounded-[12px] p-7 md:p-8 transition-all duration-200 ${tier.featured ? 'bg-verde text-arena md:-translate-y-2 shadow-cta border border-verde' : 'bg-arena-dark text-carbon border border-carbon/10 hover:border-verde/40 hover:-translate-y-[2px] hover:shadow-card'}`} data-id="element-70" data-mp="3plx7rz36l7p4" data-mpi={idx}>
              {tier.badge && <span className="absolute -top-3 left-1/2 -translate-x-1/2 font-body text-[11px] font-semibold uppercase tracking-[0.1em] px-3 py-1 rounded-full bg-azul text-arena whitespace-nowrap" data-id="element-71" data-mp="2rql38hgjlbia">
                  {tier.badge}
                </span>}
              <h4 className={`font-display text-[18px] font-bold mb-2 ${tier.featured ? 'text-arena' : 'text-carbon'}`} data-id="element-72" data-mp="35qm3pvswagx8">
                {tier.name}
              </h4>
              <p className={`font-body text-[13px] leading-[1.6] mb-6 flex-grow ${tier.featured ? 'text-arena/80' : 'text-carbon/60'}`} data-id="element-73" data-mp="3ffdwu79oz79q">
                {tier.desc}
              </p>
              <div className={`h-px w-full mb-5 ${tier.featured ? 'bg-arena/20' : 'bg-carbon/10'}`} data-id="element-74" data-mp="3ohn2aiq3sag9" />
              <div className="mb-6" data-id="element-75" data-mp="3tdauz83snlqi">
                <span className={`font-display text-[20px] font-bold ${tier.featured ? 'text-arena' : 'text-carbon'}`} data-id="element-76" data-mp="3fs6bl043mcsj">
                  {tier.setup}
                </span>
                <span className={`font-body text-[12px] ml-1.5 ${tier.featured ? 'text-arena/60' : 'text-carbon/45'}`} data-id="element-77" data-mp="3pira6njrvhbg">
                  implementación
                </span>
                <div data-id="element-78" data-mp="2wuvijx928flj">
                  <span className={`font-body text-[14px] font-medium ${tier.featured ? 'text-arena/85' : 'text-carbon/70'}`} data-id="element-79" data-mp="2wu2i1e0p2mbu">
                    {tier.monthly}
                  </span>
                </div>
              </div>
              <ul className="flex flex-col gap-1.5 mb-6" data-id="element-80" data-mp="31snf54kngpw2">
                {tier.capabilities.map(cap => <li key={cap} className={`font-body text-[12.5px] flex items-start gap-1.5 ${tier.featured ? 'text-arena/75' : 'text-carbon/60'}`} data-id="element-81" data-mp="m0g4k4n0qv51">
                    <span className={`mt-[7px] w-1 h-1 rounded-full flex-shrink-0 ${tier.featured ? 'bg-arena/50' : 'bg-verde/50'}`} data-id="element-82" data-mp="okm84b7q0jl2" />
                    {cap}
                  </li>)}
              </ul>
              <a href={getWhatsAppLink(tier.whatsapp)} target="_blank" rel="noopener noreferrer" className={`mt-auto inline-flex items-center justify-center font-display font-semibold text-[14px] px-6 py-3.5 rounded-[6px] transition-all duration-200 ${tier.featured ? 'bg-arena text-verde hover:bg-[#EAE7E0]' : 'bg-verde text-arena hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta'}`} data-id="element-83" data-mp="jmkqlupy0sbp">
                {tier.cta} <ArrowRight size={15} className="ml-1.5" data-id="element-84" data-mp="1q9pzzp4iew7p" />
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}